import React, { useState, useEffect } from 'react';
import axios from 'axios';

function NotarDashboard({ user, setUser }) {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = async () => {
    await axios.post('/api/auth/logout');
    setUser(null);
    window.location.href = '/login';
  };

  useEffect(() => {
    loadProject();
  }, []);

  const loadProject = async () => {
    try {
      const res = await axios.get('/api/projects/my');
      setProject(res.data);
    } catch (err) { console.log(err); }
    setLoading(false);
  };

  const viewPdf = async () => {
    try {
      const res = await axios.get(`/api/pdf/${project.id}/generate`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      alert('PDF konnte nicht erstellt werden: ' + (err.response?.data?.error || err.message));
    }
  };

  const downloadPdf = async () => {
    try {
      const res = await axios.get(`/api/pdf/${project.id}/generate`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `Projekt-${project.project_uid}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('PDF konnte nicht heruntergeladen werden');
    }
  };

  if (loading) return <div style={styles.container}><p>Laden...</p></div>;

  return (
    <div style={styles.container}>
      <div style={styles.pageHeader}>
        <h2>Notar Dashboard</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={styles.email}>{user.email}</span>
          <button style={styles.logoutBtn} onClick={logout}>Logout</button>
          <img src="/logo.jpg" alt="EliteHomes" style={styles.logoSmall} />
        </div>
      </div>

      {!project ? (
        <div style={styles.section}>
          <p style={{ color: '#888' }}>Ihnen wurde noch kein Projekt zugewiesen.</p>
        </div>
      ) : (
        <div style={styles.section}>
          <h3>Projekt: {project.project_uid} — {project.name}</h3>
          <p style={{ fontSize: '13px', color: '#888', marginTop: '8px' }}>
            Status: <strong style={{ color: project.status === 'daten_komplett' || project.status === 'abgeschlossen' ? '#28a745' : '#ff9800' }}>
              {project.status === 'abgeschlossen' ? 'Abgeschlossen' : project.status === 'daten_komplett' ? 'Daten komplett' : 'In Bearbeitung'}
            </strong>
          </p>

          <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
            <button style={styles.button} onClick={viewPdf}>📋 PDF Dossier anzeigen</button>
            <button style={styles.downloadBtn} onClick={downloadPdf}>⬇ PDF herunterladen</button>
          </div>

          {project.status !== 'daten_komplett' && project.status !== 'abgeschlossen' && (
            <p style={{ fontSize: '12px', color: '#ff9800', marginTop: '12px' }}>
              ⚠️ Achtung: Die Daten sind möglicherweise noch nicht vollständig.
            </p>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { maxWidth: '800px', margin: '0 auto', padding: '20px', minHeight: '100vh' },
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  section: { backgroundColor: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  email: { fontSize: '13px', color: '#888' },
  logoSmall: { width: '120px', height: 'auto' },
  logoutBtn: { padding: '8px 16px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  button: { padding: '12px 24px', backgroundColor: 'rgb(50,180,170)', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  downloadBtn: { padding: '12px 24px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
};

export default NotarDashboard;